export default __webpack_public_path__ + "38a6aaf42732e6517b82e5109dad1f26.png";